/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PricingType } from './pricingType';
import { RateType } from './rateType';


export interface GetLocationRateByCodeResponse { 
    id?: number;
    locationId?: number;
    rateType?: RateType;
    hour?: number;
    untilTimeOfDay?: string | null;
    nextDayShiftThreshold?: string | null;
    rate?: number;
    displayName?: string | null;
    displayOrder?: number;
    taxType?: PricingType;
    tax?: number | null;
    serviceFeeType?: PricingType;
    serviceFee?: number | null;
}
export namespace GetLocationRateByCodeResponse {
}


